import log from 'salvo-lite/log'
import HandyCollapse from 'handy-collapse'

class Accordion {
    constructor (theme, elem) {
        this._theme = theme
        this._elem = elem

        log.debug(this.constructor.name, 'Constructed', this)
    }

    onInit () {
        return new HandyCollapse()
    }
}

export default Accordion



// WEBPACK FOOTER //
// ./src/resources/scripts/components/Accordion.js